import EstructureLogin from "../../component/EstructureLogin.js"
import SingnInForm from "./SingnInForm.js"
 

export default function SingnIn() {
  return(
    <EstructureLogin componente={<SingnInForm/>} />
  )
}